import React from "react";
import { FormattedMessage } from "react-intl";
import TSDialog from "../../../general/dialog";

const NotAuthorizeDialog = props => {
  const {
    toggleNotAuthorizeDialog,
    visibleNotAuthorizeDialog,
    setUnauthorize,
    accountantSelectedRagSoc
  } = props;

  return (
    <TSDialog
      title={
        <FormattedMessage id="deadlines.pages.detail.dontAuthorizePayment" />
      }
      okText={<FormattedMessage id="deadlines.pages.detail.reject" />}
      type={"danger"} // sostituire con la nuova
      okButtonColorScheme="alert"
      onAbort={toggleNotAuthorizeDialog}
      visible={visibleNotAuthorizeDialog}
      onSubmit={e => {
        if (window.aptrinsic) {
          window.aptrinsic("track",
            "digital-box:DEADLINES-PAYMENT-NOT-AUTHORIZE");
        }
        setUnauthorize();
        toggleNotAuthorizeDialog();
      }}
    >
      <FormattedMessage id="deadlines.pages.detail.notAuthorizedDialogText1" />{" "}
      {accountantSelectedRagSoc}{" "}
      <FormattedMessage id="deadlines.pages.detail.notAuthorizedDialogText2" />
      <br />
      <br />
      <FormattedMessage id="deadlines.pages.detail.notAuthorizedDialogText3" />
    </TSDialog>
  );
};

export default NotAuthorizeDialog;
